export default "__VITE_ASSET__BoHlpXRi__"